import t from "@ext/localization/locale/translate";
import { PopoverInput } from "@ui-kit/Input";
import { MenuItem } from "@ui-kit/MenuItem";
import { type ComponentProps, forwardRef } from "react";

export const CatalogViewInput = forwardRef<HTMLInputElement, ComponentProps<typeof PopoverInput>>((props, ref) => (
	<MenuItem className="-ml-2 w-[calc(100%+1rem)] bg-secondary-bg-hover aria-selected:bg-secondary-bg-hover [&>span:first-child]:shrink-0">
		<PopoverInput
			autoFocus
			className="h-auto px-1.5 py-0.5"
			data-testid="catalog-view-item-input"
			placeholder={t("enter-value")}
			{...props}
			ref={ref}
		/>
	</MenuItem>
));

CatalogViewInput.displayName = "CatalogViewInput";
